import React from 'react'

import { ExampleWrapperSeamless } from '@/layout-components'

import SignInCard from '@/housefolios-components/SignIn/SignInCard'

import { Grid } from '@mui/material'

export default function SignInPage(props) {
  return (
    <>
      <ExampleWrapperSeamless>
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: "center",
            width: '100%',
            maxWidth: '100%'
          }}>
          <Grid size={12} sx={{ width: '100%', maxWidth: '100%' }}>
            <SignInCard {...props} />
          </Grid>
        </Grid>
      </ExampleWrapperSeamless>
    </>
  );
}
